var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    this.accessGroup.includes('OVR') ||
      this.userType.includes('SUP') ||
      this.userType.includes('SYS') ||
      this.userType.includes('SEN')
  )?_c('div',{staticClass:"Container"},[_c('div',{key:_vm.componentKey},[_c('script',{attrs:{"type":"application/javascript","src":"@/Services/auth.js"}}),(_vm.profileportal != 'SEN')?_c('div',[_c('Overview')],1):_vm._e()])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }